import React from "react";
import SVG_WEBSITE_LOGO from "../assets/AcrossAssistLogo.svg";

const FooterLogo = (props) => {
  return <img alt="Logo" src={SVG_WEBSITE_LOGO} style={{ width: 200 }} />;
};

export default FooterLogo;
